module.exports = "/assets/data/95e6af533c802fdd1d045b4479a9caaa-G77.data.json";